import React, { useEffect, useState } from "react";
import "./GroupLoansAppliedToLateFees.scss";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import CloseIcon from "@mui/icons-material/Close";
import GroupLoansTable from "../../../components/GroupLoansTable/GroupLoansTable";
import GroupLoansViewLateFees from "../GroupLoansViewLateFees/GroupLoansViewLateFees";
import GroupLoansViewPayments from "../GroupLoansViewPayments/GroupLoansViewPayments";
import BaseDrawer from "../../../components/UI/BaseDrawer/BaseDrawer";

const GroupLoansAppliedToLateFees = ({ selectedPayment, setLoansListView, selectedMemberName }) => {
    const [loansArray, setLoansArray] = useState([]);
    const [loading, setLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [appliedLoansView, setAppliedLoansView] = useState(null);
    const [selectedLoan, setSelectedLoan] = useState(null);
    const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);
    
    useEffect(()=>{
        console.log("GroupLoansAppliedToLateFees------------",selectedPayment?.loanpayments?.paymentid)
        getAppliedLoans();
    },[selectedPayment]);

    const getAppliedLoans = async() => {
        try {
            const response = await commonRunQuery(295, selectedPayment?.loanpayments?.paymentid);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loansArr = Array.isArray(response?.data?.body?.record)
                        ? response?.data?.body?.record
                        : [response?.data?.body?.record];
      
                setLoansArray(loansArr);
              console.log("getAppliedLoans_response==========",loansArr);
            } else {
                setLoansArray([]);
            }
        } catch (error) {
            console.log("getAppliedLoans_error==========",error);
        } finally {
            setLoading(false)
        }
    }

    const columns = [
        {
            label: 'Payment Id',
            getValue: (row) => row?.loanlatefeesapplied?.paymentid ?? ''
        },
        {
            label: 'Apply Id',
            getValue: (row) => row?.loanlatefeesapplied?.applyid ?? ''
        },
        {
            label: 'Amount Applied',
            getValue: (row) => row?.loanlatefeesapplied?.amountapplied  ?? '',
            align: 'right',
            amount: true
        },
        {
            label: 'Late Fee Id',
            getValue: (row) => row?.loanlatefeesapplied?.latefeeid ?? ''
        },
        {
            label: 'Status',
            getValue: (row) => row?.loanlatefeesapplied?.status ?? ''
        }
    ];

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedLoan(loan);
    };

    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
    };

    return (
        <Box>
            {
                appliedLoansView == null && <Box className="d-flex justify-content-between">
                    <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }}
                    className=""
                    >
                        List Of Payment Applied To Late Fees - {selectedMemberName}
                    </Typography>

                    <Button
                        className="fs-size-12 paiy-blue text-white"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setLoansListView(null);
                        }}
                    >
                        Return
                    </Button>
                </Box>
            }

            {
                appliedLoansView == null && <Box className="mt-4">
                    <GroupLoansTable
                        data={loansArray} 
                        columns={columns} 
                        title="Payment Applied Late Fees" 
                        formatRow={(row) => [
                            row.id,
                            row.record?.BorrowerName,
                            row.name,
                            row.balance,
                            row.record?.DaysPastDue,
                            row.record?.AmountDue
                        ]} 
                        viewMenu={true}
                        handleMenuOpen={handleMenuOpen}
                        downloads={false}
                        // author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
                    />
                </Box>
            }

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem
                    onClick={() => {
                        // setOpenDetailsDialog(true);
                        setOpenDetailsDrawer(true);
                        handleMenuClose();
                    }}
                >
                    View Details
                </MenuItem>
            </Menu>

            <BaseDrawer
                open={openDetailsDrawer}
                handleClose={() => setOpenDetailsDrawer(false)}
                height="70vh"
                className="loanProductInfoDrawer"
                overflow="auto"
            >
                {selectedLoan && (
                    <Box>
                        <Box className="user-accounts-tab">
                            <Box className="balance-container">
                                <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                    {/* Left Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[ 
                                            { label: "Apply ID", value: selectedLoan?.loanlatefeesapplied?.applyid },
                                            { label: "Late Fee ID", value: selectedLoan?.loanlatefeesapplied?.latefeeid },
                                            { label: "User ID", value: selectedLoan?.loanlatefeesapplied?.userid },
                                            { label: "Payment ID", value: selectedLoan?.loanlatefeesapplied?.paymentid },
                                            { label: "Confirmation Time", value: selectedLoan?.loanlatefeesapplied?.confirmationtime || "N/A" },
                                            { label: "Confirmation Ref No", value: selectedLoan?.loanlatefeesapplied?.confirmationrefno || "N/A" },
                                            { label: "Currency Code", value: selectedLoan?.loanlatefeesapplied?.currcode || "N/A" },
                                            { label: "Status", value: selectedLoan?.loanlatefeesapplied?.status === "1" ? "Confirmed" : "Not Confirmed" },
                                        ].map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">{value || "N/A"}</Box>
                                            </Box>
                                        ))}
                                    </Box>

                                    {/* Right Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[ 
                                            { label: "Amount Applied", value: selectedLoan?.loanlatefeesapplied?.amountapplied },
                                            { label: "Tax Amount Breakdown", value: selectedLoan?.loanlatefeesapplied?.taxamountbreakdown },
                                            { label: "Fee System Breakdown", value: selectedLoan?.loanlatefeesapplied?.feesystembreakdown },
                                            { label: "Fee External Breakdown", value: selectedLoan?.loanlatefeesapplied?.feeexternalbreakdown },
                                            { label: "Fee Franchisee Breakdown", value: selectedLoan?.loanlatefeesapplied?.feefranchiseebreakdown },
                                            { label: "Fee Reseller Breakdown", value: selectedLoan?.loanlatefeesapplied?.feeresellerbreakdown },
                                        ].map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">
                                                    {value ? Number(value).toLocaleString() : "N/A"}
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                )}
            </BaseDrawer>

            {/* <Dialog
                open={openDetailsDialog}
                onClose={() => setOpenDetailsDialog(false)}
                fullWidth
                maxWidth="sm"
                className="loans-dialog"
            >
                <DialogTitle>
                    <Box>
                        Loan Details
                        <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                            <IconButton onClick={() => setOpenDetailsDialog(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedLoan && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>

                                        <Box minWidth="300px" flex={1}>
                                            {[ 
                                                { label: "Apply ID", value: selectedLoan?.loanlatefeesapplied?.applyid },
                                                { label: "Late Fee ID", value: selectedLoan?.loanlatefeesapplied?.latefeeid },
                                                { label: "User ID", value: selectedLoan?.loanlatefeesapplied?.userid },
                                                { label: "Payment ID", value: selectedLoan?.loanlatefeesapplied?.paymentid },
                                                { label: "Confirmation Time", value: selectedLoan?.loanlatefeesapplied?.confirmationtime || "N/A" },
                                                { label: "Confirmation Ref No", value: selectedLoan?.loanlatefeesapplied?.confirmationrefno || "N/A" },
                                                { label: "Currency Code", value: selectedLoan?.loanlatefeesapplied?.currcode || "N/A" },
                                                { label: "Status", value: selectedLoan?.loanlatefeesapplied?.status === "1" ? "Confirmed" : "Not Confirmed" },
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">{value || "N/A"}</Box>
                                                </Box>
                                            ))}
                                        </Box>

                                        <Box minWidth="300px" flex={1}>
                                            {[ 
                                                { label: "Amount Applied", value: selectedLoan?.loanlatefeesapplied?.amountapplied },
                                                { label: "Tax Amount Breakdown", value: selectedLoan?.loanlatefeesapplied?.taxamountbreakdown },
                                                { label: "Fee System Breakdown", value: selectedLoan?.loanlatefeesapplied?.feesystembreakdown },
                                                { label: "Fee External Breakdown", value: selectedLoan?.loanlatefeesapplied?.feeexternalbreakdown },
                                                { label: "Fee Franchisee Breakdown", value: selectedLoan?.loanlatefeesapplied?.feefranchiseebreakdown },
                                                { label: "Fee Reseller Breakdown", value: selectedLoan?.loanlatefeesapplied?.feeresellerbreakdown },
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">
                                                        {value ? Number(value).toLocaleString() : "N/A"}
                                                    </Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDetailsDialog(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog> */}
            
        </Box>
    )

}

export default GroupLoansAppliedToLateFees;
